export default "__VITE_ASSET__AepxQixZ__"